import React from "react";
import { connect } from "react-redux";

export const Resume = connect()(() => (
	<div></div>
));



// WEBPACK FOOTER //
// ./src/components/resume.js